<div class="w-full h-full flex flex-col items-center justify-center gap-4 p-6 text-center">
  <app-no-content-stub imageSrc="assets/placeholders/placeholder-preview.svg">
    <div class="flex max-w-full flex-col items-center gap-2">
      <p class="text-base font-medium text-gray-900 text-center">Preview isn't available for this file type</p>
      @if (file().attachmentName) {
        <p class="text-sm text-gray-600 text-center break-all">{{ file().attachmentName }}</p>
      }
    </div>
    <app-button2 class="[&>button]:bg-offwhite" appearance="secondary" size="m" (click)="download()">
      <app-icon name="sapphire-download" />
      Download
    </app-button2>
  </app-no-content-stub>
</div>
